import Auth from '../api/auth';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';
import { setupRequestDeduplication } from '../api/requestDeduplicator';

const parseErrorCode = error => {
  // Handle 401 Unauthorized errors globally
  if (error?.response?.status === 401) {
    // Check if we're not already on a public page to avoid redirect loops
    const publicPaths = ['/app/login', '/app/auth', '/auth'];
    const isPublicPath = publicPaths.some(path =>
      window.location.pathname.startsWith(path)
    );

    if (!isPublicPath) {
      // Clear all auth data and redirect to login
      deleteIndexedDBOnLogout();
      clearCookiesOnLogout();
      // Note: clearCookiesOnLogout already handles the redirect
      return new Promise(() => {}); // Return a never-resolving promise to stop further processing
    }
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }

  // Setup request deduplication for GET requests
  setupRequestDeduplication(wootApi);

  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
